<template>
	<div>
		<v-dialog v-model="dialog_opening" no-click-animation persistent lazy full-width width="290px" transition="dialog-bottom-transition">
        	<v-card>
        	  	<v-card-text>
        	  		<v-form data-vv-scope="field">
        	  			<v-layout row wrap>

        	  				<v-flex xs12 sm12 md12>
					           	<v-radio-group v-model="nature" row>
					           		<v-radio :label="$root.fn_payOrReceive(1, $parent.Form.groupTypeId)" :value="1"></v-radio>
					           		<v-radio :label="$root.fn_payOrReceive(0, $parent.Form.groupTypeId)" :value="0"></v-radio>
							    </v-radio-group>
					        </v-flex>

	        	  			<v-flex xs12 sm12 md12>
        	  					<v-text-field
        	  						prefix="₹"
		        	  			  	label="Amount"
		        	  			  	placeholder=" "
		        	  			  	type="number"
		        	  			  	v-model.number="amount"
		        	  			  	v-validate="'required|decimal:2'"
				               		data-vv-name="amount"
				               		:error-messages="errors.collect('field.amount')" 
		        	  			></v-text-field>
		        	  			</v-flex>
        	  			</v-layout>
        	  		</v-form>
        	  	</v-card-text>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog">close</v-btn>
		          <v-btn color="blue darken-1" flat @click.native="fn_checkValidations">done</v-btn>
		        </v-card-actions>
	        </v-card>	
      	</v-dialog>
	</div>
</template>

<script>
export default{
	data(){	
		return{
			dialog_opening: false,
			amount:null,
			nature:null
		}
	},
	methods:{
		openDialogWeb: function () {
			this.errors.clear('fields');
			this.nature = this.$parent.Form.openingNature;
			this.amount = this.$parent.Form.openingAmount;
			this.dialog_opening = true;
		},
		closeDialogWeb: function () {
			this.dialog_opening = false;
		},
		fn_checkValidations: function () {
			this.$validator.validateAll('fields').then((result) => {
				if(result){
					if(this.amount < 0){
						this.showToast("Opening amount can't be negative");
						return;
					}
					this.$parent.fn_setOpening(this.amount, this.nature)
				}
		    });
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/ledgers/dialogs/dialog_opening.vue